module.exports = __webpack_public_path__ + "cb2cd0507ea05bac8682519c287014c4.jpg";